import React from "react";
import "./Get_enquiry.css";
import { useNavigate } from "react-router-dom";

function Get_enquiry() {
  const navigate = useNavigate();

  return (
    <>
      <section className="Get_enquiry">
        <div className="container">
          <div
            className="img_holder"
            onClick={() => navigate("/career")}
          >
            <img
              src="/assets/images/get_enquiry/Get_enquiry.png"
              alt="Get Enquiry"
              className="Get_enquiry_img"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Get_enquiry;